import getTreksFactory from './getTreks';
import getCommentsFactory from './getComments';
import getTrekDetailsFactory from './getTrekDetails';
import getTrekByTrekNameFactory from './getTrekByTrekName';
import getTrekByIdFactory from './getTreksById';
// import forkTrekFactory from './forkTrek';
// import saveTrekOverviewEditsFactory from './saveTrekOverviewEdits';
// import getTrekPreferenceFactory from './getTrekPreferences';
// import updateTrekPreferenceFactory from './updateTrekPreferences';
// import saveTrekPreferenceFactory from './saveTrekPreference';
import getDayDateFactory from './getDayData';
import getCardDetailsFactory from './getCardDetail';
import getLodgeDetailsFactory from './getLodgeDetail';
import getPlaceByIdFactory from './getPlaceByPlaceId';
import getPlaceThemesFactory from './getPlaceThemes';
import getLodgesForPlaceFactory from './getLodgesForPlace';
import getPlaceThemesByCategoryFactory from './getPlaceThemeByCategory';
import getPlaceThemesBySearchAndCategoryFactory from './getPlaceThemesBySearchAndCategory';
import getSidetripsForPlaceFactory from './getSidetripsForPlace';
import getPlacesForPlaceFactory from './getPlacesForPlace';
import getThemeDetailsFactory from './getThemeDetails';
import getFlightSearchReultsFactory from './getFlightSearchResults';
import reserverFlightFactory from './reserveFlight';
import bookFlightFactory from './bookFlight';
import getFlightProcessIdFactory from './getFlightProcessId';
import followTrekFactory from './followTrek';
import getFlightsForPlaceFactory from './getFlightsForPlace';
import savePlaceEditsFactory from './savePlaceEdits';
import uploadPlacesImageFactory from './uploadPlacesImage';
import getTrekPaymentReviewFactory from './getTrekPaymentReview';

export default function generateApi(ajax, getSession) {
  return {
    getTreks: getTreksFactory(ajax, getSession),
    getcomments: getCommentsFactory(ajax, getSession),
    getTrekDetails: getTrekDetailsFactory(ajax, getSession),
    getTrekByTrekName: getTrekByTrekNameFactory(ajax, getSession),
    getTrekById: getTrekByIdFactory(ajax, getSession),
    // forkTrek: forkTrekFactory(ajax, getSession),
    // saveTrekOverviewEdits: saveTrekOverviewEditsFactory(ajax, getSession),
    // getTrekPreference: getTrekPreferenceFactory(ajax, getSession),
    // updateTrekPreference: updateTrekPreferenceFactory(ajax, getSession),
    // saveTrekPreference: saveTrekPreferenceFactory(ajax, getSession),
    getDayData: getDayDateFactory(ajax, getSession),
    getCardDetail: getCardDetailsFactory(ajax, getSession),
    getLodgeDetail: getLodgeDetailsFactory(ajax, getSession),
    getPlaceById: getPlaceByIdFactory(ajax, getSession),
    getPlaceThemes: getPlaceThemesFactory(ajax, getSession),
    getLodgesForPlace: getLodgesForPlaceFactory(ajax, getSession),
    getPlaceThemesByCategory: getPlaceThemesByCategoryFactory(ajax, getSession),
    getPlaceThemesBySearchAndCategory: getPlaceThemesBySearchAndCategoryFactory(
      ajax,
      getSession
    ),
    getSidetripsForPlace: getSidetripsForPlaceFactory(ajax, getSession),
    getPlacesForPlace: getPlacesForPlaceFactory(ajax, getSession),
    getThemeDetails: getThemeDetailsFactory(ajax, getSession),
    getFlightSearchResults: getFlightSearchReultsFactory(ajax, getSession),
    reserverFlight: reserverFlightFactory(ajax, getSession),
    bookFlight: bookFlightFactory(ajax, getSession),
    getFlightProcessId: getFlightProcessIdFactory(ajax, getSession),
    followTrek: followTrekFactory(ajax, getSession),
    getFlightsForPlace: getFlightsForPlaceFactory(ajax, getSession),
    savePlaceEdits: savePlaceEditsFactory(ajax, getSession),
    uploadPlacesImage: uploadPlacesImageFactory(ajax, getSession),
    getTrekPaymentReview: getTrekPaymentReviewFactory(ajax),
  };
}



// WEBPACK FOOTER //
// ./src/services/index.js